import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PEJobHistoriesCardActions = {
  initPeJobHistoriesCard: ({ commit }, index) => {
    commit('setPeJobHistoriesCardLock', { index, lock: true })
  },
  peJobHistoriesMultipleCardCreate: async ({ dispatch }, sections) => {
    return sections.reduce((acc, section) => {
      if (acc) return acc.then(_ => dispatch('peJobHistoriesCardCreate', { section, index: 'new' }))
      else return dispatch('peJobHistoriesCardCreate', { section, index: 'new' })
    }, null)
  },
  peJobHistoriesCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post('/party_characteristics', {
        job_histories: {
          party_id: party.id,
          job_title: section.job_title,
          company: section.company,
          start_date: section.start_date,
          start_date_format: section.start_date_format,
          start_date_uncertain: section.start_date_uncertain,
          end_date: section.end_date,
          end_date_format: section.end_date_format,
          end_date_uncertain: section.end_date_uncertain,
          non_us_data: section.non_us_data,
          city: section.city,
          state: section.state,
          zip: section.zip,
          int_state: section.int_state,
          int_zip: section.int_zip,
          country_id: section.country_id,
        },
      }).
      then(({ data }) => {
        commit('setPeJobHistoriesCardLock', { index: 'new', lock: true })
        commit('setPeJobHistoriesCardLock', { index: data.id, lock: true })
        commit('pePatchCharacteristicNew', {
          characteristic: 'job_histories',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peJobHistoriesCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/job_histories/${section.id}`).
      then(({ data }) => {
        commit('setPeJobHistoriesCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'job_histories',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peJobHistoriesCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        job_histories: {
          party_id: party.id,
          job_title: section.job_title,
          company: section.company,
          start_date: section.start_date,
          start_date_format: section.start_date_format,
          start_date_uncertain: section.start_date_uncertain,
          end_date: section.end_date,
          end_date_format: section.end_date_format,
          end_date_uncertain: section.end_date_uncertain,
          non_us_data: section.non_us_data,
          city: section.city,
          state: section.state,
          zip: section.zip,
          int_state: section.int_state,
          int_zip: section.int_zip,
          country_id: section.country_id,
        },
        id,
      }).
      then(({ data }) => {
        commit('setPeJobHistoriesCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'job_histories',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peJobHistoriesCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          job_histories: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const jobHistories = data.job_histories

        commit('setPeJobHistoriesCardLock', { index, lock: true })
        commit('pePatchParty', {
          job_histories: jobHistories || [],
        })
      }).
      catch(handleError)
  },
  peJobHistoriesCardAddSection: ({ commit }) => {
    commit('setPeJobHistoriesCardLock', { index: 'new', lock: false })
    commit('addPeJobHistoriesCardSection', {
      id: null,
      job_title: null,
      company: null,
      start_date: null,
      start_date_format: null,
      start_date_uncertain: null,
      end_date: null,
      end_date_format: null,
      end_date_uncertain: null,
      non_us_data: null,
      city: null,
      state: null,
      zip: null,
      int_state: null,
      int_zip: null,
      country_id: null,
    })
  },
}

export const PEJobHistoriesCardMutations = {
  setPeJobHistoriesCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.JobHistoriesCard) Vue.set(state.partyEdit.partySections, 'JobHistoriesCard', {})
    Vue.set(state.partyEdit.partySections.JobHistoriesCard, index, lock)
  },
  addPeJobHistoriesCardSection: (state, section) => {
    state.partyEdit.party.job_histories.push(section)
  },
  peJobHistoriesCardCreateUndo: state => {
    state.partyEdit.party.job_histories.pop()
    Vue.set(state.partyEdit.partySections.JobHistoriesCard, 'new', true)
  },
}

export const PEJobHistoriesCardGetters = {
  peJobHistoriesCardLock: state => index => state.partyEdit.partySections.JobHistoriesCard[index],
  peJobHistoriesCardHasNewSection: (_, getters) => !!getters.
    peParty.
    job_histories?.
    find(language => language.id === null),
}
